var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Index'),_c('News'),_c('Books')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }